var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-doc-content"},[_c('c-title',[_vm._v("单据详情")]),_c('div',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }